// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import './App.css';
import Home from './Home';
import Catering from './Catering';
import ClientOrders from './Order.js';
import AboutUs from './AboutUs';
import Contact from './contact';
import PrivacyPolicy from './PrivacyPolicy';
import Download from './Download';
import DeleteAccount from './DeleteAccount';

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-shell">
        <Navbar />
        <div className="app-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catering" element={<Catering />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/orders" element={<ClientOrders />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/download" element={<Download />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
